import { DocumentContent } from './document-content';

export interface DocumentFile extends DocumentContent {
    FileId: number;
    FileName: string;
    Links: {
        Self: string;
        Content: string;
        Content_v2: string;
    };
}

export const isDocumentFile = (file: DocumentContent): file is DocumentFile =>
    Object.prototype.hasOwnProperty.call(file, 'FileId');


// WEBPACK FOOTER //
// ./src/phoenix/domain/document-file.ts